module.exports = __webpack_public_path__ + "img/zxjp_desc.f8bc3b2.png";